/**
 * Alpine component for the week-day toggle section inside the registration modal.
 * Rendered server-side; this component only handles visual toggling and
 * the "cannot deselect the last day" guard.
 * The hidden input :value="selectedDays.join(',')" is submitted with the parent form.
 */
export default () => ({
    selectedDays: [],

    init() {
        // Pre-selected days are provided by the server via data-selected-days="1,3,5"
        const raw = this.$el.dataset.selectedDays || '';
        this.selectedDays = raw ? raw.split(',').map(Number).filter(Boolean) : [];
    },

    toggle(value) {
        // Prevent deselecting the last remaining day
        if (this.selectedDays.includes(value) && this.selectedDays.length === 1) return;

        this.selectedDays = this.selectedDays.includes(value)
            ? this.selectedDays.filter(d => d !== value)
            : [...this.selectedDays, value];

        // Notify the parent form component so it can re-evaluate submitEnabled
        this.$dispatch('days-changed');
    },

    isSelected(value) {
        return this.selectedDays.includes(value);
    },
});
